import { useAnvaFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/anvaFlowsConfigureStore';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import ContentWrapper from '@flows/src/components/flows-configure/shared/ContentWrapper';
import FlowsConfigureInsuranceGroupItems from '@flows/src/components/flows-configure/insurances/FlowsConfigureInsuranceGroupItems';
import { FLOWS_CONFIG_PATH } from '@flows/src/FlowsConfigRouter';
import { useFlowsConfigureParams } from '@flows/src/hooks/flows-configure/useFlowsConfigureParams';
import LoadingSpinner from '@common/src/components/LoadingSpinner';
import useQueryParams from '@common/src/hooks/useQueryParams';
import { PartyType } from '../../../../../types/SMT';
import { useAnvaFlowsInsuranceTags } from '@flows/src/api/anva-flows/getAnvaFlowsInsuranceTags';

const FlowsConfigureInsurancesAnva: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { flowId } = useFlowsConfigureParams();
  const queryparams = useQueryParams();
  const partyType = (queryparams.get('type') as PartyType) || 'CUSTOMER';

  const { data: anvaInsurances, isLoading } =
    useAnvaFlowsInsuranceTags(partyType);
  const [error, setError] = useState<string | undefined>(undefined);

  const handleNext = () => {
    const firstInsurance = useAnvaFlowsConfigureStore.getState().insurances[0];
    if (!firstInsurance) {
      setError(t('Please select an insurance'));
      return;
    }
    if (error) setError(undefined);

    history.push({
      pathname: `${FLOWS_CONFIG_PATH}/${flowId}/insurances/${firstInsurance.id}/coverages`,
      search: window.location.search,
    });
  };

  return (
    <ContentWrapper
      onNext={handleNext}
      question={t('What kind of insurance are you looking for?')}
      error={error}
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <FlowsConfigureInsuranceGroupItems
          clearError={() => setError(undefined)}
          isError={!!error}
          items={anvaInsurances?.items || []}
        />
      )}
    </ContentWrapper>
  );
};

export default FlowsConfigureInsurancesAnva;
